<ng-template #content let-modal class="">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Privacy Notice and Application Details</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="overflow-auto">
      <h5>Privacy Notice</h5>
      <p>
        The Biodiversity Conservation Trust of NSW (BCT or we/us) is subject to the <i>Privacy and Personal Information Protection Act 1998</i> (Privacy Act) in managing your personal information.
        We are committed to protecting your privacy.
      </p>
      <p>
        The BCT is part of the Department of Planning, Industry and Environment (DPIE). The DPIE <a href="http://www.environment.nsw.gov.au/resources/about/oeh-privacy-management-plan-170267.pdf" target="_blank">Privacy Management Plan</a> describes how the agency meets its privacy obligations.
      </p>
      <p>
        This notice describes how the BCT will manage your personal information that you (the applicant) provide when you apply to sell credits to the BCT.
      </p>
      <p>Personal information means information or opinion about an individual whose identity is apparent or can be reasonably ascertained from the information or opinion.</p>
      <p>
        In the above circumstances you may also provide the personal information of other persons.
        This could include information about other persons that together comprise the applicant.
        Before providing the personal information of any other person you must first obtain the
        consent of that person for the BCT to collect their information and for it to be used in accordance
        with this privacy notice.
      </p>
      <p>We may use personal information collected from you for the following purposes:</p>
      <ul>
        <li>to assess your application to sell credits to the BCT.</li>
        <li>to support the BCT in purchasing the credits (if a purchase is agreed), including preparing the credit transfer application form and other documents for the purchase.</li>
        <li>to obtain information that is held by DPIE and the BCT to assess your application and purchase the credits. This includes information to verify the ownership and attributes of the credits that are the subject of this application, as well as attributes of the agreement that created the credits, including information on the Total Fund Deposit for the agreement.</li>
      </ul>
      <p>We may share the personal information that you provide with DPIE when it is consistent with the above purposes.</p>
      <p>If you sell credits to the BCT then information on the credit transfer will be recorded in the public register held by DPIE in accordance with Part 9 of the <i>Biodiversity Conservation Act 2016.</i></p>
      <p>We will not otherwise publish or disclose your personal information to any other person unless you have provided consent, or we are permitted or required to do so under law.</p>
      <p>There is no legal requirement for you to provide us with personal information. However, if you do not provide all required information requested, we may not be able to consider your application.</p>
      <p>Your personal information will be stored in a secured database.</p>
      <p>You have the right to access your personal information that we hold. You also have a right to request that we update or amend this information. If you would like more information, or have any questions regarding privacy, then please contact:</p>
      <p>
        NSW Biodiversity Conservation Trust<br />
        Locked Bag 5022<br />
        Parramatta   NSW   2124<br />
        Phone: 1300 992 688<br />
        Email: info@bct.nsw.gov.au<br />
      </p>
      <h5>No Legal Relationship</h5>
      <p>
        This application form does not create any legal relationship and is not a recommendation,
        offer or invitation to enter into a legal relationship, contract, agreement
        or other arrangement in respect of the goods or services the subject of this application.
        There will be no binding agreement between the applicant(s) and
        the Biodiversity Conservation Trust (NSW) (BCT) until a Credit Sale Agreement has been issued by the BCT and signed by the applicant(s).
      </p>
      <p>
        Nothing in this application or in the consideration of the application obliges the BCT to
        enter into any agreement with the applicant(s), creates a “process contract” or other implied contract,
        obliges the BCT to consider or accept any application, or stops the BCT from considering a non-conforming application,
        or prevents the BCT from changing the way it manages the Open FPO program (Program) or evaluates applications.
      </p>
      <p>
        Without limiting the foregoing, the Guide is a policy only and does not give rise to any legally enforceable obligations on the part of the BCT.
      </p>
      <h5>Confidentiality Notice</h5>
      <p>
        The information in this document whether in electronic or print format is confidential,
        is intended for the internal use of the BCT and the use by an applicant for the purpose of
        preparing a bona fide application in accordance with this application form.
        The information must otherwise not be reproduced, distributed or used
        without first obtaining the written permission of an authorised officer of the BCT.
      </p>
      <p>
        All intellectual property rights and confidential information contained within this documentation,
        in accordance with the Guide and the <i>Copyright Act 1968</i>, will remain the property of the applicant(s)
        with all efforts taken by the BCT to protect confidential or commercially sensitive information and trade secrets.
      </p>
      <h5>Copyright</h5>
      <p>
        This document is subject to copyright.  Apart from any use permitted under the <i>Copyright Act 1968</i> and subject to the confidentiality requirements below, no part may be reproduced by any process, nor may any other exclusive right be exercised, without the prior written permission of the BCT.
      </p>

    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary pull-right mr-3" (click)="close();">Close</button>
  </div>
</ng-template>

